import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';

import { Navigation } from './components/navigation';
import { Header } from './components/header';
import { Features } from './components/features';
import SEO from './components/SEO'; // ✅ SEO using react-head
import { About } from './components/about';
import { Services } from './components/services';
import { Gallery } from './components/gallery';
import { Testimonials } from './components/testimonials';
import { Team } from './components/Team';
import { Contact } from './components/contact';
import { Projects } from './components/projects';
import { BringYourIdeatoLife } from './components/BringYourIdeatoLife';
import DataProtection from './components/DataProtection';
import Imprint from './components/Imprint';
import Cookies from './components/Cookies';
import { OurVision } from './components/vision';
import { HowItWorks } from './components/HowItWorks';

import IdeaSteps from './data/ideaSteps.json';
import Bringyoreideatolife from './data/bringyoreideatolife.json';
import Datenschutzhinweise from './data/datenschutzhinweise.json';
import ProjectsData from './data/projects.json';
import JsonData from './data/data.json';
import DeveloperStepsData from './data/developerSteps.json';

import './App.css';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [pathname]);
  return null;
};

const ScrollToHashElement = () => {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 0);
      }
    }
  }, [hash]);
  return null;
};

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [ideaSteps, setIdeaSteps] = useState([]);
  const [datenschutzhinweise, setDatenschutzhinweise] = useState(null);
  const [bringyoreideatolife, setBringyoreideatolife] = useState({
    title: '',
    intro: '',
    steps: [],
  });
  const [projects, setProjects] = useState([]);
  const [developerSteps, setDeveloperSteps] = useState([]);

  useEffect(() => {
    setLandingPageData(JsonData);
    setIdeaSteps(IdeaSteps);
    setDatenschutzhinweise(Datenschutzhinweise);
    setBringyoreideatolife(Bringyoreideatolife);
    setProjects(ProjectsData);
    setDeveloperSteps(DeveloperStepsData);
  }, []);

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <ScrollToHashElement />
      <Navigation />

      <Routes>
        {/* =======================
             HOME
        ======================== */}
        <Route
          path="/"
          element={
            <>
              <SEO
                title="Home"
                description="Welcome to Mahanc , Digital innovation, creative solutions and scalable development."
                href="/"
              />

              <section id="header" data-autoscroll="true">
                <Header data={landingPageData.Header} />
              </section>

              <section id="vision">
                <OurVision data={landingPageData.OurVision} />
              </section>

              <section id="services">
                <Services data={landingPageData.Services} />
              </section>

              <section id="team">
                <Team data={landingPageData.Team} />
              </section>

              <section id="contact">
                <Contact data={landingPageData.Contact} />
              </section>
            </>
          }
        />

        {/* =======================
             HOW IT WORKS
        ======================== */}
        <Route
          path="/how-it-works"
          element={
            <>
              <SEO
                title="How It Works"
                description="Learn how Mahanc develops, designs, and launches your digital product step by step."
                href="/how-it-works"
              />

              <section id="HowItWorks">
                <HowItWorks
                  data={landingPageData.HowItWorks}
                  ideaSteps={ideaSteps}
                  developerSteps={developerSteps}
                />
              </section>

              <section id="contact">
                <Contact data={landingPageData.Contact} />
              </section>
            </>
          }
        />

        {/* =======================
             IDEA PAGE
        ======================== */}
        <Route
          path="/idea"
          element={
            <>
              <SEO
                title="Bring Your Idea to Life"
                description="Turn your idea into a real product with Mahanc , structured steps, guidance, and development expertise."
                href="/idea"
              />

              <section id="bring-idea">
                <BringYourIdeatoLife
                  bringyoreideatolife={bringyoreideatolife}
                />
              </section>

              <section id="contact">
                <Contact data={landingPageData.Contact} />
              </section>
            </>
          }
        />

        {/* =======================
             PROJECTS
        ======================== */}
        <Route
          path="/projects"
          element={
            <>
              <SEO
                title="Projects"
                description="Explore projects listed by Mahanc."
                href="/projects"
              />

              <section id="projects">
                <Projects />
              </section>

              <section id="contact">
                <Contact data={landingPageData.Contact} />
              </section>
            </>
          }
        />

        {/* =======================
             DATA PROTECTION
        ======================== */}
        <Route
          path="/data-protection"
          element={
            <>
              <SEO
                title="Data Protection"
                description="Learn how Mahanc protects your personal data in accordance with GDPR."
                href="/data-protection"
              />

              <DataProtection datenschutzhinweise={datenschutzhinweise} />

              <section id="contact">
                <Contact data={landingPageData.Contact} />
              </section>
            </>
          }
        />

        {/* =======================
             IMPRINT
        ======================== */}
        <Route
          path="/imprint"
          element={
            <>
              <SEO
                title="Imprint"
                description="Official company information and legal disclosures for Mahanc."
                href="/imprint"
              />

              <Imprint />

              <section id="contact">
                <Contact data={landingPageData.Contact} />
              </section>
            </>
          }
        />

        {/* Cookies Page (optional)
        <Route path="/cookies" element={<Cookies />} /> */}
      </Routes>
    </Router>
  );
};

export default App;
